import React, { FC, useCallback } from "react";
import styles from "./SpotlightrVideoThumbnail.module.css";
import classNames from "classnames";
import { IUserTrainingCourseVideoSummary } from "src/@types/ImpiricaPlatformApi";
import _ from "lodash";
import { Icon } from "src/components/icons/Icon";
import { Play, CircleCheck } from "lucide-react";

type SpotlightrGalleryVideoProps = {
	video: IUserTrainingCourseVideoSummary;
	onLaunchVideo?: (video: IUserTrainingCourseVideoSummary) => void;
};
export const SpotlightrGalleryVideoThumbnail: FC<
	SpotlightrGalleryVideoProps
> = ({ video, onLaunchVideo }) => {
	const _onClick = useCallback(() => {
		if (onLaunchVideo) {
			onLaunchVideo(video);
		}
	}, [video]);

	const _onKeyDown = useCallback(
		(e: React.KeyboardEvent<HTMLDivElement>) => {
			if (e.key === "Enter") {
				if (onLaunchVideo) {
					onLaunchVideo(video);
				}
			}
		},
		[video]
	);

	return (
		<div data-testid="video-thumbnail">
			<div className={styles.videoTitleContainer}>
				<h3 id={video.id} className={styles.videoTitle}>
					{video.name}
				</h3>
				{video.complete && <Icon icon={CircleCheck} />}
			</div>
			<div className={styles.video} onClick={_onClick} onKeyDown={_onKeyDown}>
				<img src={video.thumbnail} key={video.id} alt="Training Video" />

				<Icon
					icon={Play}
					filled
					className={classNames(styles.playIcon)}
					color="white"
				/>
			</div>
		</div>
	);
};
